export default __webpack_public_path__ + "static/media/eye-open.9afdd13a.svg";